type Unpacked<T> = T extends (infer U)[] ? U : T;

export type PathResult<T> = {
  path: any[]
  <TKey extends keyof T>(key: TKey): PathResult<NonNullable<T[TKey]>>
  any: PathResult<NonNullable<Unpacked<T>>>
  atIndex: (index: number) => PathResult<NonNullable<Unpacked<T>>>
}

export function buildPath<T>() {
  function subpath<T, TKey extends keyof T>(parent: string[], key: TKey): PathResult<NonNullable<T[TKey]>> {
    const newPath = [ ...parent, key as string ];
    const x = (<TSubKey extends keyof T[TKey]>(subkey: TSubKey) => subpath<T[TKey], TSubKey>(newPath, subkey)) as PathResult<NonNullable<T[TKey]>>;
    x.path = [ ...parent, key as string ];
    x.toString = function () {return this.path.join(".");};
    x.any = x;
    x.atIndex = (index: number) => {
      newPath.push(`[${index}]`);
      x.toString = function () {return newPath.join(".");};
      return x;
    };
    return x;
  }

  return <TKey extends keyof (T)>(key: TKey) => subpath<T, TKey>([], key);
}
